import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IPos } from './pos';
import * as myGlobals from '../global';
import { map } from 'rxjs/operators';
import {HttpClientSecured} from "../services/http-client-secured";

@Injectable({
  providedIn: 'root'
})
export class PosesService {
  private _posesURL = myGlobals.baseApi + '/webadmin/v1/points-of-sale';
  private _addPosURL = myGlobals.baseApi + '/webadmin/v1/point-of-sale';
  formData: IPos;

  constructor(private http: HttpClientSecured) {}

  getPoses() {
    return this.http.get<any>(this._posesURL);
  }

  getPos(itemid: number): Observable<IPos | undefined> {
    return this.getPoses().pipe(map((poses: IPos[]) => poses.find(p => p.id === itemid)));
  }

  addPos(bin) {
    return this.http.post<any>(this._addPosURL, bin);
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
